<div class="flex flex-column sound-debugger-container">
  <span class="uppercase weight-bold font-s">Music Volume: {{ musicVolume * 10 }}%</span>
  <span class="uppercase m-t-10 weight-bold">Participants Volume</span>
  @for (participant of participantsState | keyvalue; track participant.key) {
    <div class="flex justify-between items-center w-full">
      @if (participant.key !== userId) {
        <span class="m-r-20 text-overflow-ellipsis">{{ getUserName(participant.key) }}</span>
        <span>{{ ((participant.value.volume ?? 0) * 100).toFixed(0) }}%</span>
      }
    </div>
  }
</div>
